import {
  WSButton,
  WSButtons,
  WSContainer,
  WSGridCentered,
  WSPanel,
  WSText,
  WSTodoList
} from "@wingspanhq/fe-component-library";
import React from "react";
import { CSVLink } from "react-csv";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { ProjectOnboardingLayout } from "../../../components/ProjectOnboardingLayout/ProjectOnboardingLayout";

export interface BulkUploadCollaboratorsStep1Props {}

export interface UploadCollaborator {
  email: string;
  contractorId?: string;
  firstName: string;
  lastName: string;

  name?: string;
  businessName?: string;
  companyStructure?: string;
  ssn?: string;
  ein?: string;

  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export const BulkUploadCollaboratorsStep1: React.FC<BulkUploadCollaboratorsStep1Props> = () => {
  useBrowserPageTitle("Wingspan - Bulk upload collaborators");
  const history = useHistory();

  const downloadExampleCollaborators = [
    {
      firstName: "Wade",
      lastName: "Warren",
      email: "wade@wingspan.app",
      phoneNumber: "",
      contractorId: ""
    }
  ];
  const csvProps = {
    filename: `Wingspan_Bulk_Upload_Collaborators_Template.csv`,
    headers: [
      { label: "First Name", key: "firstName" },
      { label: "Last Name", key: "lastName" },
      { label: "Email", key: "email" },
      { label: "Phone number", key: "phoneNumber" },
      { label: "External Collaborator ID", key: "contractorId" }
    ],
    data: downloadExampleCollaborators
  };

  return (
    <ProjectOnboardingLayout progress={(100 / 3) * 1}>
      <WSContainer verticalPadding>
        <WSGridCentered M={8} S={6} XS={6}>
          <WSText.Label color="grey600" mt="S" mb="M" pt="S">
            1 of 3
          </WSText.Label>
          <WSText.Heading2 mb="S">
            Bulk upload collaborators with a spreadsheet
          </WSText.Heading2>
          <WSPanel>
            <WSTodoList
              mb="M"
              items={[
                {
                  mark: "1.",
                  content: (
                    <>
                      <WSText.LabelBold>
                        Upload a spreadsheet of collaborators
                      </WSText.LabelBold>
                      <WSText.Label mt="XS">
                        Upload a CSV or Excel spreadsheet of your collaborators.
                      </WSText.Label>
                    </>
                  )
                },
                {
                  mark: "2.",
                  content: (
                    <>
                      <WSText.LabelBold>
                        Confirm collaborator information
                      </WSText.LabelBold>
                      <WSText.Label mt="XS">
                        Review your imported collaborators to ensure their
                        information is correct.
                      </WSText.Label>
                    </>
                  )
                },
                {
                  mark: "3.",
                  content: (
                    <>
                      <WSText.LabelBold>Invite collaborators</WSText.LabelBold>
                      <WSText.Label mt="XS">
                        New collaborators will be automatically invited to
                        Wingspan.
                      </WSText.Label>
                    </>
                  )
                }
              ]}
            />
            <WSButtons>
              <CSVLink
                {...csvProps}
                onClick={() =>
                  history.push(
                    "/member/invoices/contacts/collaborators/bulk-create/upload"
                  )
                }
              >
                <WSButton.Secondary fullWidth icon="download">
                  Download Example
                </WSButton.Secondary>
              </CSVLink>
              <WSButton
                fullWidth
                onClick={() =>
                  history.push(
                    "/member/invoices/contacts/collaborators/bulk-create/upload"
                  )
                }
              >
                Upload collaborators
              </WSButton>
            </WSButtons>
          </WSPanel>
        </WSGridCentered>
      </WSContainer>
    </ProjectOnboardingLayout>
  );
};
